"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var DataGridColors_1 = require("./DataGridColors");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var CSSMacros_1 = require("./CSSMacros");
var HeaderColumn = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderColumn, _super);
    function HeaderColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hovered: false };
        _this.rootElement = null;
        // public componentDidUpdate(): void {
        //   this.syncFocus();
        // }
        // private syncFocus(): void {
        //   if (this.props.isFocused && this.cellRef) {
        //     this.cellRef.focus();
        //   }
        // }
        // private handleFocus = (e: React.FocusEvent<HTMLDivElement>): void => {
        //   this.props.onCellFocus(DataGrid.FocusLocation.Header, this.props.colIdx);
        // }
        _this.onStartResize = function (event) {
            var resizeMouseX = widgets_1.getClientPosition(event).x;
            var node = _this.rootElement;
            var rect = node.getBoundingClientRect();
            var initialWidth = rect.right - rect.left;
            var handleMouseMove = function (e) {
                var delta = e.clientX - resizeMouseX;
                _this.props.onColumnResize(_this.props.col, Math.max(initialWidth + delta, _this.props.minWidth));
                e.preventDefault();
            };
            var handleMouseUp = function (e) {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                e.preventDefault();
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            event.preventDefault();
        };
        _this.columnDivider = (React.createElement(widgets_1.PointerEventWrapper, { pointerDown: _this.onStartResize },
            React.createElement("div", { className: 'tb-react-dg-hdivider tb-disable-selection', role: 'separator', style: {
                    cursor: 'col-resize',
                    bottom: 0,
                    position: 'absolute',
                    right: -6,
                    top: 0,
                    width: 12,
                    zIndex: 1,
                } })));
        _this.handleClick = function (e) {
            if (_this.props.onHeaderClick) {
                _this.props.onHeaderClick(null, { colIdx: _this.props.colIdx, colKey: _this.props.col.dataKey, rowIdx: NaN }, e);
            }
        };
        _this.handleContextMenu = function (e) {
            if (_this.props.onHeaderContextMenu) {
                _this.props.onHeaderContextMenu(null, { colIdx: _this.props.colIdx, colKey: _this.props.col.dataKey, rowIdx: NaN }, e);
            }
        };
        _this.handleDoubleClick = function (e) {
            if (_this.props.onHeaderDoubleClick) {
                _this.props.onHeaderDoubleClick(null, { colIdx: _this.props.colIdx, colKey: _this.props.col.dataKey, rowIdx: NaN }, e);
            }
        };
        _this.handleRef = function (element) {
            _this.rootElement = element;
        };
        // ugly helper functions to allow pure rendering
        _this.setHovered = function () {
            _this.setState({ hovered: true });
        };
        _this.setNotHovered = function () {
            _this.setState({ hovered: false });
        };
        return _this;
    }
    // private cellRef: HTMLElement;
    // private updateCellRef = (ref: HTMLElement) => {
    //   this.cellRef = ref;
    // }
    HeaderColumn.prototype.componentDidMount = function () {
        if (this.props.reportWidthFn) {
            this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this));
        }
        // this.syncFocus();
    };
    HeaderColumn.prototype.render = function () {
        var pointerEventWrapperProps = {
            pointerClick: this.handleClick,
            pointerDoubleClick: this.handleDoubleClick
        };
        var col = this.props.col;
        var isSortable = col.sortable !== false;
        var isResizable = col.resizable !== false;
        // Determine column header classes
        var classes = ['tb-react-dg-hcell'];
        if (isSortable) {
            classes.push('tb-react-dg-hcell-sortable');
        }
        if (isResizable) {
            classes.push('tb-react-dg-hcell-resizable');
        }
        var attrs = {
            'aria-colindex': this.props.colIdx + 1,
            'aria-rowindex': 1,
            'aria-selected': this.props.isSelected,
            'aria-sort': this.props.sorted ? (this.props.sortAscending ? 'ascending' : 'descending') : 'none',
            className: classes.join(' '),
            onMouseEnter: this.setHovered,
            onMouseLeave: this.setNotHovered,
            onContextMenu: this.handleContextMenu,
            role: 'columnheader',
            style: tslib_1.__assign(tslib_1.__assign({}, CSSMacros_1.PreventUserSelect), { height: '100%' }),
        };
        if (col.headerTooltip) {
            attrs.title = col.headerTooltip;
        }
        if (this.props.sorted) {
            attrs['data-tb-test-id'] = this.props.sortAscending ? 'data-grid-hcell-ascending' : 'data-grid-hcell-descending';
        }
        var formatter = this.props.col.headerFormatter;
        var formatterProps = tslib_1.__assign(tslib_1.__assign({}, this.props), this.state);
        var content = formatter
            ? formatter(formatterProps)
            : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: col.headerText, testId: col.name + '-HeaderFormatter' });
        var divWrapperProps = HeaderColumn.getDivWrapperProps(this.props.isSelected, this.props.showVerticalGridLines);
        divWrapperProps.style.minWidth = this.props.minWidth;
        divWrapperProps.style.width = this.props.width;
        return (React.createElement("div", tslib_1.__assign({}, divWrapperProps, { ref: this.handleRef }),
            React.createElement(widgets_1.PointerEventWrapper, tslib_1.__assign({}, pointerEventWrapperProps),
                React.createElement("div", tslib_1.__assign({}, attrs), content)),
            col.resizable === false ? null : this.columnDivider));
    };
    HeaderColumn.displayName = 'DataGridHeaderColumn';
    HeaderColumn.element = React.createFactory(HeaderColumn);
    return HeaderColumn;
}(React.PureComponent));
exports.HeaderColumn = HeaderColumn;
(function (HeaderColumn) {
    function getDivWrapperProps(isSelected, showVerticalGridLines) {
        return {
            className: 'tb-react-dg-hcol',
            style: {
                backgroundColor: isSelected ? DataGridColors_1.DataGridColors.Selected : undefined,
                borderBottom: "1px solid " + (isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : DataGridColors_1.DataGridColors.HeaderBorder),
                borderRight: showVerticalGridLines ? "1px solid " + (isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : DataGridColors_1.DataGridColors.VerticalGridLine) : undefined,
                boxSizing: 'border-box',
                display: 'inline-block',
                height: '100%',
                position: 'relative',
            }
        };
    }
    HeaderColumn.getDivWrapperProps = getDivWrapperProps;
})(HeaderColumn = exports.HeaderColumn || (exports.HeaderColumn = {}));
exports.HeaderColumn = HeaderColumn;
//# sourceMappingURL=HeaderColumn.js.map